import { MobileOpCode, QueryGetAccessEventsForTenantArgs } from 'graphql/generated/graphqlTypes';
import {
  GET_ACCESS_EVENTS_FOR_TENANT,
  GET_ALL_VISITORS_CARDS,
  GET_CARDS,
  GET_CURRENT_HOST,
  GET_CURRENT_TENANT,
  GET_CURRENT_VISITOR,
  GET_DOORS_FOR_TENANT_WITH_LOCATIONS,
  GET_DOORS_FOR_TENANT_WITH_OFFICE_MODE,
  GET_LOCATIONS_WITH_DOORS_FOR_TENANT,
  GET_MFA_PREFERENCE,
  GET_REST_API_KEYS,
  GET_TENANT_LEGAL_DOCUMENTS,
  GET_TENANT_NAME,
  GET_TENANT_REGISTRATION_INFO,
  GET_VISITOR_GROUPS_FOR_TENANT,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_ACCESS_GRANTS,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_IS_OFFICE_MODE_ENABLED,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS,
  GET_VISITOR_GROUPS_WITH_PERMISSIONS
} from 'graphql/queries';
import {
  GET_ACCESS_EVENTS_FOR_TENANT as GET_ACCESS_EVENTS_FOR_TENANT_V2,
  GET_ALL_VISITORS_FOR_TENANT,
  GET_ALL_VISITORS_GROUPS,
  GET_ALL_VISITORS_GROUPS_WITHOUT_NESTED_RESOLVERS,
  GET_ALL_VISITORS_VISITOR_GROUPS,
  GET_DOORS_WITHOUT_NESTED_RESOLVERS,
  GET_LOCATIONS_WITHOUT_NESTED_RESOLVERS,
  GET_QR_CODE_VISITS_FOR_TENANT,
  GET_VISITOR_DETAILS,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_AND_ROLE,
  GET_VISITOR_GROUPS_FOR_TENANT_WITH_SCHEDULES,
  GET_VISITOR_GROUPS_WITHOUT_NESTED_RESOLVERS,
  GET_VISITORS_WITHOUT_NESTED_RESOLVERS
} from 'graphql/v2/queries';
import { mockedGetAllVisitorsForTenantData } from 'mocks/graphqlApollo/query/getAllVisitorsForTenant';
import { mockedGetAllVisitorsGroupsWithoutNestedResolversDataForQuery } from 'mocks/graphqlApollo/query/getAllVisitorsGroupsWithoutNestedResolvers';
import { mockedGetCardsDataForQuery } from 'mocks/graphqlApollo/query/getCards';
import { mockedGetCurrentTenantDataForQuery } from 'mocks/graphqlApollo/query/getCurrentTenant';
import { mockedGetDoorsWithoutNestedResolversDataForQuery } from 'mocks/graphqlApollo/query/getDoorsWithoutNestedResolvers';
import { mockedGetLocationsWithoutNestedResolversDataForQuery } from 'mocks/graphqlApollo/query/getLocationsWithoutNestedResolvers';
import { mockedGetMfaPreferenceDataForQuery } from 'mocks/graphqlApollo/query/getMfaPreferenceDataForQuery';
import { mockedGetQrCodeVisitsForTenantData } from 'mocks/graphqlApollo/query/getQrCodeVisitsForTenant';
import { mockedGetRestAPIKeysDataForQuery } from 'mocks/graphqlApollo/query/getRestAPIKeys';
import { mockedGetTenantLegalDocumentsDataForQuery } from 'mocks/graphqlApollo/query/getTenantLegalDocuments';
import { mockedGetTenantNameDataForQuery } from 'mocks/graphqlApollo/query/getTenantName';
import { mockedGetTenantRegistrationInfoDataForQuery } from 'mocks/graphqlApollo/query/getTenantRegistrationInfo';
import { mockedGetVisitorByIdDataForQuery } from 'mocks/graphqlApollo/query/getVisitorById';
import { mockedGetVisitorDetailsData } from 'mocks/graphqlApollo/query/getVisitorDetails';
import { mockedGetVisitorGroupsWithoutNestedResolversDataForQuery } from 'mocks/graphqlApollo/query/getVisitorGroupsWithoutNestedResolvers';
import { mockedGetVisitorsWithoutNestedResolversDataForQuery } from 'mocks/graphqlApollo/query/getVisitorsWithoutNestedResolvers';
import { mockVisitorsWithGroups } from 'mocks/graphqlMocks/visitorFixtures';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';
import {
  mockedGetAccessEventsForTenantDataForQueryFirstFetch,
  mockedGetAccessEventsForTenantDataForQuerySecondFetch,
  mockedGetAccessEventsForTenantDataForTimeWindow
} from '../graphqlApollo/query/getAccessEventsForTenant';
import {
  mockedGetCurrentVisitorAdminDataForQuery,
  mockedGetCurrentVisitorUnitTestsDataForQuery
} from '../graphqlApollo/query/getCurrentVisitor';
import { mockedGetDoorsForTenantWithLocationsDataUnitTests } from '../graphqlApollo/query/getDoorsForTenantWithLocations';
import { mockedGetDoorsWithOfficeDaysForTenantDataUnitTests } from '../graphqlApollo/query/getDoorsForTenantWithOfficeMode';
import { mockedGetLocationWithDoorsForTenantDataUnitTests } from '../graphqlApollo/query/getLocationWithDoorsForTenant';
import { mockedGetVisitorGroupsForTenantWithAccessGrantsDataDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithAccessGrants';
import { mockedGetVisitorGroupsForTenantWithIsAdminGroupDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithIsAdminGroupDataForQuery';
import { mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithIsOfficeModeEnabled';
import {
  mockedGetVisitorGroupsForTenant,
  mockedGetVisitorGroupsForTenantWithMembersAndRoleDataForQuery
} from '../graphqlApollo/query/getVisitorGroupsForTenantWithMembersAndRole';
import {
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery,
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery1,
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQueryWithoutFilters
} from '../graphqlApollo/query/getVisitorGroupsForTenantWithMembersAndTypes';
import { mockedGetVisitorGroupsWithSchedulesForTenantDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithSchedules';
import { mockedGetVisitorGroupsForTenantWithTypesDataForQuery } from '../graphqlApollo/query/getVisitorGroupsForTenantWithTypes';

const visitorDetailsQueries = mockVisitorsWithGroups.map((visitor) => ({
  id: visitor.id,
  data: mockedGetVisitorDetailsData(visitor)
}));

export const queries = [
  {
    request: {
      query: GET_CURRENT_HOST
    },
    result: { data: mockedGetCurrentVisitorAdminDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_CURRENT_TENANT
    },
    result: { data: mockedGetCurrentTenantDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_CURRENT_VISITOR
    },
    result: { data: mockedGetCurrentVisitorUnitTestsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_DOORS_FOR_TENANT_WITH_OFFICE_MODE
    },
    result: { data: mockedGetDoorsWithOfficeDaysForTenantDataUnitTests },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS
    },
    result: { data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQueryWithoutFilters },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS,
      variables: {
        filter: {
          type: VisitorGroupType.CoContractors
        }
      }
    },
    result: { data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_AND_ROLE,
      variables: {
        filter: {
          type: VisitorGroupType.CoContractors
        }
      }
    },
    result: { data: mockedGetVisitorGroupsForTenantWithMembersAndRoleDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS,
      variables: {
        filter: {
          type: VisitorGroupType.Installers
        }
      }
    },
    result: { data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery1 },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_WITH_PERMISSIONS,
      variables: {
        filter: {
          type: VisitorGroupType.AzureAd
        }
      }
    },
    result: { data: mockedGetVisitorGroupsForTenantWithIsAdminGroupDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_SCHEDULES
    },
    result: { data: mockedGetVisitorGroupsWithSchedulesForTenantDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT
    },
    result: { data: mockedGetVisitorGroupsForTenantWithTypesDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_ACCESS_EVENTS_FOR_TENANT,
      variables: { filter: { actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] } }
    },
    result: { data: mockedGetAccessEventsForTenantDataForQueryFirstFetch },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_ACCESS_EVENTS_FOR_TENANT,
      variables: {
        nextToken: 'mockedNextToken',
        filter: { actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] }
      }
    },
    result: { data: mockedGetAccessEventsForTenantDataForQuerySecondFetch },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  // The two entries above are registered against the *legacy* access events query; the v2 hooks send
  // a different document, so they need their own mock. The dashboard charts query a rolling window
  // whose timestamps can never be matched exactly, so they are matched on the presence of a
  // `dateRange` instead and served events generated for whatever window and actions they asked for.
  {
    request: {
      query: GET_ACCESS_EVENTS_FOR_TENANT_V2,
      variables: (variables: QueryGetAccessEventsForTenantArgs) => Boolean(variables?.filter?.dateRange)
    },
    // every dashboard chart queries this window, so the mock has to stay usable for all of them
    maxUsageCount: Number.POSITIVE_INFINITY,
    result: (variables: QueryGetAccessEventsForTenantArgs) => ({
      data: mockedGetAccessEventsForTenantDataForTimeWindow(variables?.filter)
    })
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_IS_OFFICE_MODE_ENABLED
    },
    result: { data: mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_LOCATIONS_WITH_DOORS_FOR_TENANT
    },
    result: { data: mockedGetLocationWithDoorsForTenantDataUnitTests },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_DOORS_FOR_TENANT_WITH_LOCATIONS
    },
    result: { data: mockedGetDoorsForTenantWithLocationsDataUnitTests },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_ACCESS_GRANTS
    },
    result: { data: mockedGetVisitorGroupsForTenantWithAccessGrantsDataDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_TENANT_LEGAL_DOCUMENTS
    },
    result: { data: mockedGetTenantLegalDocumentsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_TENANT_REGISTRATION_INFO
    },
    result: { data: mockedGetTenantRegistrationInfoDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_REST_API_KEYS
    },
    result: { data: mockedGetRestAPIKeysDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_TENANT_NAME,
      variables: {
        azureTenantId: 'mockedAzureTenantId'
      }
    },
    result: { data: mockedGetTenantNameDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_MFA_PREFERENCE
    },
    result: { data: mockedGetMfaPreferenceDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_CARDS
    },
    result: { data: mockedGetCardsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_ALL_VISITORS_GROUPS
    },
    result: { data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQueryWithoutFilters },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_ALL_VISITORS_GROUPS_WITHOUT_NESTED_RESOLVERS
    },
    result: { data: mockedGetAllVisitorsGroupsWithoutNestedResolversDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_WITHOUT_NESTED_RESOLVERS
    },
    result: { data: mockedGetVisitorGroupsWithoutNestedResolversDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITORS_WITHOUT_NESTED_RESOLVERS
    },
    result: { data: mockedGetVisitorsWithoutNestedResolversDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_LOCATIONS_WITHOUT_NESTED_RESOLVERS
    },
    result: { data: mockedGetLocationsWithoutNestedResolversDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_DOORS_WITHOUT_NESTED_RESOLVERS
    },
    result: { data: mockedGetDoorsWithoutNestedResolversDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_ALL_VISITORS_GROUPS,
      variables: { filter: { id: 'mockedVisitorGroupIdExternalUsers1' } }
    },
    result: () => ({
      data: {
        getVisitorGroupsForTenant: [
          generateMockVisitorGroup({
            id: 'mockedVisitorGroupIdExternalUsers1',
            name: 'co-contractors1',
            type: VisitorGroupType.CoContractors
          })
        ]
      }
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_ALL_VISITORS_GROUPS_WITHOUT_NESTED_RESOLVERS,
      variables: { filter: { id: 'mockedVisitorGroupIdExternalUsers1' } }
    },
    result: () => ({
      data: {
        getVisitorGroupsForTenant: [
          generateMockVisitorGroup({
            id: 'mockedVisitorGroupIdExternalUsers1',
            name: 'co-contractors1',
            type: VisitorGroupType.CoContractors
          })
        ]
      }
    }),
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_AND_ROLE,
      variables: { filter: { id: 'mockedVisitorGroupIdExternalUsers1' } }
    },
    result: { data: mockedGetVisitorGroupsForTenantWithMembersAndRoleDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.Administrators
        }
      }
    },
    result: { data: mockedGetVisitorGroupsForTenant },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.Installers
        }
      }
    },
    result: { data: mockedGetVisitorGroupsForTenant },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_VISITOR_DETAILS,
      variables: {
        id: 'mockedVisitorIdExternalUser6'
      }
    },
    result: { data: mockedGetVisitorByIdDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  ...visitorDetailsQueries.map(({ id, data }) => ({
    request: {
      query: GET_VISITOR_DETAILS,
      variables: { id }
    },
    result: { data },
    maxUsageCount: Number.POSITIVE_INFINITY
  })),
  {
    request: {
      query: GET_ALL_VISITORS_CARDS
    },
    result: { data: mockedGetCardsDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_ALL_VISITORS_FOR_TENANT
    },
    result: { data: mockedGetAllVisitorsForTenantData },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_QR_CODE_VISITS_FOR_TENANT
    },
    result: { data: mockedGetQrCodeVisitsForTenantData },
    maxUsageCount: Number.POSITIVE_INFINITY
  }
];
